import React from "react";

import LoadingIcon from "../LoadingIcon";
import PolyLoader from "../PolyLoader";
import Text from "../Text";

import * as Styled from "./Loader.styled";

export interface LoaderProps {
  spinner?: boolean;
  logo?: boolean;
  fullScreen?: boolean;
  inProjectPage?: boolean;
  spinnerText?: string;
  className?: string;
}

export const Loader: React.FC<LoaderProps> = ({
  spinner = false,
  logo = false,
  fullScreen = false,
  inProjectPage = true,
  spinnerText = "Loading",
  className,
}) => (
  <Styled.Loader
    $fullScreen={fullScreen}
    $inProjectPage={inProjectPage}
    $logo={logo}
    $spinner={spinner}
    className={className}
  >
    {(logo || spinner) && <>{logo ? <PolyLoader /> : <LoadingIcon />}</>}
    <div>
      <Text color="textSecondary" variant="bodySemibold">
        {spinnerText}
      </Text>
    </div>
  </Styled.Loader>
);
